// Shared labels, colors and micro-components for the CRM pages.
import React from "react";

export const SERVICE_CATEGORIES = [
  ["curtains_blinds", "Curtains & Blinds"],
  ["sofa_upholstery", "Sofa / Upholstery"],
  ["carpentry_joinery", "Carpentry / Joinery"],
  ["kitchen_wardrobe", "Kitchen / Wardrobe"],
  ["flooring", "Flooring"],
  ["wallpaper_wall_panels", "Wallpaper / Wall Panels"],
  ["renovation_fitout", "Renovation / Fit-out"],
  ["holiday_homes", "Holiday Homes"],
  ["furniture", "Furniture"],
  ["unknown_review", "Unknown / Admin Review"],
  ["other", "Other"],
];

export const LEAD_STATUSES = [
  ["new", "New", "#6E1F2C"],
  ["ai_qualifying", "AI Qualifying", "#A6822F"],
  ["qualified", "Qualified", "#3F6E2C"],
  ["site_visit_proposed", "Visit Proposed", "#2C5F6E"],
  ["measurement_completed", "Measured", "#2C5F6E"],
  ["negotiation", "Negotiation", "#A6822F"],
  ["not_relevant", "Not Relevant", "#7A6B5F"],
  ["human_takeover", "Human Takeover", "#A3141A"],
  ["site_visit_scheduled", "Site Visit Scheduled", "#3F6E2C"],
  ["quotation_pending", "Quotation Pending", "#D4A963"],
  ["quotation_sent", "Quotation Sent", "#56151F"],
  ["follow_up", "Follow Up", "#A6822F"],
  ["won", "Won", "#3F6E2C"],
  ["lost", "Lost", "#7A6B5F"],
];

export const LEAD_SCORES = [
  ["hot", "Hot", "#A3141A"],
  ["warm", "Warm", "#A6822F"],
  ["cold", "Cold", "#7A6B5F"],
];

export const DIGEST_SECTIONS = [
  ["hot_leads", "Hot leads requiring action"],
  ["new_website_leads", "New website leads"],
  ["new_whatsapp_leads", "New WhatsApp leads"],
  ["overdue_followups", "Overdue follow-ups"],
  ["followups_due_today", "Follow-ups due today"],
  ["quotations_pending", "Quotations pending"],
  ["site_visits", "Site visits today/tomorrow"],
  ["unassigned_leads", "Unassigned leads"],
  ["possible_duplicates", "Possible duplicates"],
  ["human_takeover", "Human takeover recommended"],
];

export const label = (list, key) => (list.find(([k]) => k === key) || [null, key || "—"])[1];
export const color = (list, key) => (list.find(([k]) => k === key) || [null, null, "#7A6B5F"])[2];

export function Chip({ list, value, testid }) {
  const c = color(list, value);
  return (
    <span
      data-testid={testid}
      className="inline-flex items-center text-[9px] tracking-[0.14em] uppercase px-2 py-0.5 border whitespace-nowrap"
      style={{ color: c, borderColor: `${c}55`, background: `${c}10` }}
    >
      {label(list, value)}
    </span>
  );
}

export const inputCls =
  "w-full bg-white border border-[#6E1F2C]/20 px-3 py-2 text-sm text-[#1C110C] focus:outline-none focus:border-[#6E1F2C]";

export function Field({ label: l, children, className = "" }) {
  return (
    <div className={className}>
      <label className="block text-[9px] tracking-[0.22em] uppercase text-[#7A6B5F] mb-1">{l}</label>
      {children}
    </div>
  );
}

export function PageHead({ eyebrow, title, children }) {
  return (
    <div className="flex items-end justify-between gap-4 flex-wrap mb-6">
      <div>
        <p className="text-[10px] tracking-[0.32em] uppercase text-[#A6822F]">{eyebrow}</p>
        <h1 className="font-serif-display text-2xl md:text-3xl text-[#1C110C]">{title}</h1>
      </div>
      <div className="flex items-center gap-2 flex-wrap">{children}</div>
    </div>
  );
}

export function BarList({ items, testid }) {
  const max = Math.max(1, ...items.map((i) => i.count));
  return (
    <ul className="space-y-2" data-testid={testid}>
      {items.length === 0 && <li className="text-xs text-[#7A6B5F] italic">No data yet.</li>}
      {items.map((i) => (
        <li key={i.key} className="flex items-center gap-3">
          <span className="w-36 shrink-0 text-[11px] text-[#3E2A22] truncate capitalize">
            {String(i.key).replace(/_/g, " ")}
          </span>
          <div className="flex-1 bg-[#6E1F2C]/8 h-4">
            <div className="h-4 bg-[#6E1F2C]" style={{ width: `${(i.count / max) * 100}%` }} />
          </div>
          <span className="w-8 text-right text-xs text-[#1C110C] font-medium">{i.count}</span>
        </li>
      ))}
    </ul>
  );
}
